<template>
  <vs-row vs-justify="center" id="counter-stat">
    <vs-card>
      <vs-row>
        <vs-col vs-lg="6" vs-md="8" vs-sm="4" vs-xs="12">
          <vs-select
            v-model="selectedCounter"
            class="w-100"
            @change="filterStat"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in counters"
            />
          </vs-select>
        </vs-col>
        <vs-col
          vs-lg="3"
          vs-md="3"
          vs-sm="4"
          vs-xs="12"
          class="d-flex align-items-center"
        >
          <vs-input
            v-model="selectedDate"
            @input="filterStat"
            type="month"
            class="w-100 mb-3"
          />
        </vs-col>
        <vs-col
          vs-lg="3"
          vs-md="3"
          vs-sm="4"
          vs-xs="12"
          class="d-flex align-items-center"
        >
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-col
      vs-lg="4"
      vs-xs="12"
      vs-sm="12"
      v-if="PermissionsConfig.queue_allowed"
    >
      <vs-card class="active-user-card">
        <FeedbackNoteSummary :data="feedbackNote"></FeedbackNoteSummary>
      </vs-card>
    </vs-col>

    <vs-col
      vs-lg="4"
      vs-xs="12"
      vs-sm="12"
      v-if="PermissionsConfig.booking_allowed"
    >
      <vs-card class="active-user-card">
        <FeedbackMonthSummary
          :data="feedbackNoteMonthly"
        ></FeedbackMonthSummary>
      </vs-card>
    </vs-col>

    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <FeedbackSummary
        :data="feedbackSummary"
        :total="feedback"
        :rating="rating"
      ></FeedbackSummary>
    </vs-col>

    <!-- counter stat in current month -->
    <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
      <vs-card>
        <div slot="header" class="center"></div>
        <div>
          <CounterCharts
            v-if="ticketsInMonth"
            :headerTitle="$t('Statistics.Tabs.Frequency.Counter.TicketsMonth')"
            :visitFrequencyParams="{ periodical: 'MONTHLY' }"
            :tickets="ticketsInMonth"
          />
        </div>
      </vs-card>
    </vs-col>

    <!-- counter stat in current year -->
    <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
      <vs-card>
        <div slot="header" class="center"></div>
        <div>
          <CounterCharts
            v-if="ticketsInYear"
            :headerTitle="$t('Statistics.Tabs.Frequency.Counter.Tickets')"
            :visitFrequencyParams="{ periodical: 'YEARLY' }"
            :tickets="ticketsInYear"
          />
        </div>
      </vs-card>
    </vs-col>

    <vs-popup
      :active.sync="onBoardingActive"
      title="Welcome to Liberrex"
      class="onboarding"
    >
      <div>
        <vs-row>
          <vs-col vs-w="12" class="text-center">
            <h2 class="text-primary mb-2">
              {{ $t("Dashboard.OnBoarding.Title") }}
            </h2>
            <p class="p-0 text-cyan">
              {{ $t("Dashboard.OnBoarding.Text") }}
            </p>
            <p class="p-2 text-cyan">
              <img
                :src="require('@/assets/images/placeholder/welcome.jpg')"
                class="welcome-img"
              />
            </p>
            <vs-row>
              <vs-col class="mt-2">
                <vs-button
                  class="w-50 text-uppercase"
                  color="primary"
                  size="large"
                  @click="
                    onBoardingActive = false;
                    showQuickSetup();
                  "
                >
                  {{ $t("Dashboard.OnBoarding.SetupButton") }}
                </vs-button>
              </vs-col>
              <vs-col class="mt-2">
                <vs-button
                  class="w-50 text-uppercase"
                  color="dark"
                  type="border"
                  size="large"
                  @click="onBoardingActive = false"
                >
                  {{ $t("Dashboard.OnBoarding.LaterButton") }}
                </vs-button>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <QuickSetupModal ref="QuickSetupModal"></QuickSetupModal>
  </vs-row>
</template>
<script>
// //////////////////////////////////////////
// Import Components Here
// //////////////////////////////////////////
import FeedbackNoteSummary from "../../components/widgets/counter/FeedbackSummary";
import FeedbackMonthSummary from "../../components/widgets/counter/FeedbackMonthSummary";
import FeedbackSummary from "../../components/widgets/feedback/FeedbackSummary";
import { teamService, counterService } from "../../_services";
import { mapState } from "vuex";
import router from "../../_helpers/router";
import QuickSetupModal from "../../components/onboarding/QuickSetupModal";
import CounterCharts from "../../components/statistics/CounterCharts";
import ServicePieChart from "../../components/statistics/ServicePieChartHome";

// //////////////////////////////////////////
// Export Here
// //////////////////////////////////////////
export default {
  name: "ClassicDashboard",
  data: () => ({
    title: "ClassicDashboard",
    titleEn: "Click here to open user profile menu.",
    // Month Table
    onBoardingActive: false,
    feedbackNote: null,
    feedbackNoteMonthly: null,
    rating: 0,
    selectedCounter: null,
    selectedDate: null,
    month1: 0,
    monthoptions1: [
      { text: "Monthly", value: 0 },
      { text: "Daily", value: 1 },
      { text: "Weekly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    feedbackSummary: {},
    feedback: 0,
    reports: {
      bookings: {},
      queues: {},
      services: [],
      visits: {},
    },
    steps: [
      {
        target: "#profile-menu", // We're using document.querySelector() under the hood
        header: {
          title: "Profile Menu",
        },
        modifiers: {
          arrow: {
            element: ".v-step__arrow",
          },
        },
        params: {
          placement: "left",
        },
      },
      {
        target: "#lang-box",
        params: {
          placement: "bottom-start",
        },
      },
      {
        target: "#notifications-popup",
        params: {
          placement: "bottom-end",
        },
      },
    ],
    ticketsInMonth: null,
    ticketsInYear: null,
    counters: [],
  }),
  methods: {
    goToNextPage() {
      router.push({ path: "/queues?istour=on" });
    },
    skipTour() {
      localStorage.setItem("skipTour", "true");
      this.$tours["Dashboard"].stop();
    },
    showQuickSetup() {
      this.$refs.QuickSetupModal.show();
    },
    filterStat() {
      this.showLoading();
      let date = {
        month: this.$moment(this.selectedDate).format("MM"),
        year: this.$moment(this.selectedDate).format("YYYY"),
      };

      // get stats
      teamService
        .counterStat(this.selectedCounter, date)
        .then(
          function(res) {
            this.feedbackSummary = res.feedback;
            res.feedback.data.forEach((el) => (this.feedback += el));
            this.rating = res.rating;

            // feedback note
            this.feedbackNote = res.feedback_note;
            this.feedbackNoteMonthly = res.Monthly_feedback_note;

            // counterStats
            this.ticketsInMonth = res.Monthly;
            this.ticketsInYear = res.Yearly;
          }.bind(this)
        )
        .catch(function(err) {
          console.log(err);
        })
        .finally(
          function() {
            this.hideLoading();
          }.bind(this)
        );
    },
    showLoading() {
      this.$vs.loading({
        container: "#counter-stat",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#counter-stat > .con-vs-loading");
    },
  },
  components: {
    FeedbackNoteSummary,
    FeedbackMonthSummary,
    FeedbackSummary,
    QuickSetupModal,
    CounterCharts,
    ServicePieChart,
  },
  mounted() {
    this.showLoading();
    counterService
      .getAll(this.$route.params.id)
      .then(
        function(res) {
          this.counters = res.counters;
          this.selectedCounter = this.counters[0].id;
          this.selectedDate = this.$moment().format("YYYY-MM");

          let date = {
            month: this.$moment(this.selectedDate).format("MM"),
            year: this.$moment(this.selectedDate).format("YYYY"),
          };

          // get stats
          teamService
            .counterStat(this.selectedCounter, date)
            .then(
              function(res) {
                this.feedbackSummary = res.feedback;
                res.feedback.data.forEach((el) => (this.feedback += el));
                this.rating = res.rating;

                // feedback note
                this.feedbackNote = res.feedback_note;
                this.feedbackNoteMonthly = res.Monthly_feedback_note;

                // counterStats
                this.ticketsInMonth = res.Monthly;
                this.ticketsInYear = res.Yearly;
              }.bind(this)
            )
            .catch(function(err) {
              console.log(err);
            });
        }.bind(this)
      )
      .catch(
        function(err) {
          console.log(err);
        }.bind(this)
      )
      .finally(
        function() {
          this.hideLoading();
        }.bind(this)
      );
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      business_info: (state) => state.account.user.business,
    }),
  },
};
</script>
<style>
.onboarding .vs-popup--header {
  display: none !important;
}
.onboarding .welcome-img {
  max-height: 50%;
  max-width: 300px;
  width: 100%;
}
.center {
  display: flex;
  justify-content: center;
}
</style>
